import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { Skeleton } from '@vk-hr-tek/ui/Skeleton';
import { Link } from '@vk-hr-tek/ui/Link';
import { useInject } from '@vk-hr-tek/core/ioc';

import { useSelector } from '@app/hooks';

import { BellNotificationsRouter } from '../../../../types';
import { selectBellNotificationsStatus } from '../../../../slice';

interface FooterProps {
  onClose(): void;
}

export const Footer = ({ onClose }: FooterProps) => {
  const status = useSelector(selectBellNotificationsStatus);

  const router = useInject<BellNotificationsRouter>(BellNotificationsRouter);

  const handleClick = () => {
    router.goToNotificationsPage();
    onClose();
  };

  return (
    <Box
      px="16"
      py="16"
      display="flex"
      alignItems="center"
      border={1}
      borderBottom={0}
      borderLeft={0}
      borderRight={0}
      borderColor="stroke.primary"
    >
      {status === 'loading' ? (
        <Box>
          <Skeleton variant="rect" height={18} width={228} />
        </Box>
      ) : (
        <Box>
          <Link stroke={false} onClick={handleClick}>
            Перейти ко всем уведомлениям
          </Link>
        </Box>
      )}
    </Box>
  );
};
